module.exports = __webpack_public_path__ + "img/drt13.a1cceee9.png";